<!--  -->
<template>
  <div>
    <el-table
      ref="multipleTable"
      :row-key="getRowKeys"
      :data="tableData"
      height="550"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        :reserve-selection="true"
        type="selection"
        width="55"
      />
      <el-table-column
        prop="corp_id"
        label="corp_id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="follow_user_id"
        label="follow_user_id"
        align="center"
      />
      <!-- <el-table-column
        prop="name"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column> -->

    </el-table>
    <div style="text-align: right;margin:10px 0 0 0">
      <el-button type="primary" @click="choose">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getFollowUserList } from '@/api/providerAccountManagement/servicePorviderList1.js'
export default {
  components: {},
  data() {
    return {
      corpid: null,
      tableData: [],
      multipleSelection: [],
      contactsnamearr: [],
      key: Math.random()
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    send(corpid, contactsnamearr) {
      this.corpid = corpid
      this.contactsnamearr = contactsnamearr
      console.log('111', contactsnamearr)
      this.getlist()
    },
    async getlist() {
      const data = await getFollowUserList({
        page: 1,
        pageSize: 100,
        corp_id: this.corpid
      })
      this.tableData = data.data.list
      this.SelectionChange()

      console.log('data', data)
    },
    choose(item) {
      this.$emit('callback', this.multipleSelection)
    },
    handleSelectionChange(val) {
      // console.log('val', val)
      // var obj = {}
      // val = val.reduce(function(item, next) {
      //   obj[next.id] ? '' : obj[next.id] = true && item.push(next)
      //   return item
      // }, [])
      // this.multipleSelection = []
      // this.multipleSelection = val
      // console.log('111', val)
      // const stockSelectlist = []
      // val.forEach((el) => {
      //   stockSelectlist.push(el)
      // })
      // console.log(stockSelectlist)
      // this.multipleSelection = stockSelectlist
    },

    SelectionChange() {
      this.$nextTick(() => {
        // 这里把数据重新赋值一下，不然就会出现bug，从第一页翻到第二页可以保留，在回到第一页选中的就没了
        const table = this.contactsnamearr
        table.forEach(row => {
          console.log('row', row)
          this.$refs.multipleTable.toggleRowSelection(row, true)
        })
      })
      // let arr = []
      // const set = this.contactsnamearr.map(item => {
      //   return item.id
      // })
      // // 过滤出已选择项和table数据中accountId对应上的数据，完成回显
      // arr = this.tableData.filter(item => {
      //   return set.includes(item.id)
      // })
      // this.$nextTick(() => {
      //   arr.forEach((item) => {
      //     this.$refs.multipleTable.toggleRowSelection(item)
      //   })
      // })
    },
    getRowKeys(row) {
      return row.follow_user_id
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
